import { useLang } from "@/contexts/LangContext";
import { useSettings } from "@/contexts/SettingsContext";

/**
 * Return the site-copy override from settings if set, otherwise fall back to i18n key.
 * Usage: const heroTitle = useSiteCopy("hero_title", "hero.title");
 */
export function useSiteCopy() {
  const { lang, t } = useLang();
  const { settings } = useSettings();

  return (settingsKey, i18nKey) => {
    const override = settings?.[`${settingsKey}_${lang}`];
    if (override && String(override).trim().length > 0) return override;
    return t(i18nKey);
  };
}
